// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-control-label span[data-v-ac914fce]{white-space:normal}", ""]);
// Exports
module.exports = exports;
